const FALSE_POSITIVE_RULES = [
    'color-contrast',
    'scrollable-region-focusable',
    'autocomplete-valid',
    'aria-required-children'
];
function a11yIgnore(...rules) {
    return {
        'data-a11y-ignore': rules.join(' ')
    };
}
export { FALSE_POSITIVE_RULES, a11yIgnore };
